import { jsx as _jsx } from "react/jsx-runtime";
import { LeftCategoryNavigation } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/LeftCategoryNavigation";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
export var CategoryPageSidebar = function() {
    var selectedCategory = useCurrentCategoryModel();
    var viewport = useViewport();
    if (viewport.isMobile || viewport.isTablet) {
        return null;
    }
    return /*#__PURE__*/ _jsx(LeftCategoryNavigation, {
        selectedCategory: selectedCategory
    });
};
